import { render, staticRenderFns } from "./StampDuty.vue?vue&type=template&id=ac862440&scoped=true&"
import script from "./StampDuty.vue?vue&type=script&lang=js&"
export * from "./StampDuty.vue?vue&type=script&lang=js&"
import style0 from "./StampDuty.vue?vue&type=style&index=0&id=ac862440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac862440",
  null
  
)

export default component.exports